import React, { createContext, useContext, useEffect, useState } from 'react';

const WMO_MAP = {
  0:  { emoji: '☀️',  label: 'Clear' },
  1:  { emoji: '🌤️', label: 'Mainly Clear' },
  2:  { emoji: '⛅',  label: 'Partly Cloudy' },
  3:  { emoji: '☁️',  label: 'Overcast' },
  45: { emoji: '🌫️', label: 'Foggy' },
  48: { emoji: '🌫️', label: 'Foggy' },
  51: { emoji: '🌦️', label: 'Drizzle' },
  53: { emoji: '🌦️', label: 'Drizzle' },
  55: { emoji: '🌦️', label: 'Drizzle' },
  61: { emoji: '🌧️', label: 'Rainy' },
  63: { emoji: '🌧️', label: 'Rainy' },
  65: { emoji: '🌧️', label: 'Heavy Rain' },
  71: { emoji: '🌨️', label: 'Snow' },
  73: { emoji: '🌨️', label: 'Snow' },
  75: { emoji: '❄️',  label: 'Heavy Snow' },
  80: { emoji: '🌧️', label: 'Showers' },
  81: { emoji: '🌧️', label: 'Showers' },
  82: { emoji: '🌧️', label: 'Heavy Showers' },
  95: { emoji: '⛈️',  label: 'Thunderstorm' },
  96: { emoji: '⛈️',  label: 'Thunderstorm' },
  99: { emoji: '⛈️',  label: 'Thunderstorm' },
};

const WeatherContext = createContext(null);

export function WeatherProvider({ children }) {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchWeather() {
      try {
        const geoRes = await fetch('https://ipapi.co/json/');
        const geo = await geoRes.json();
        if (cancelled) return;

        const { city, latitude, longitude } = geo;
        if (!latitude || !longitude) return;

        const wxRes = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true&temperature_unit=celsius`
        );
        const wx = await wxRes.json();
        if (cancelled) return;

        const { temperature, weathercode } = wx.current_weather;
        const { emoji, label } = WMO_MAP[weathercode] ?? { emoji: '🌡️', label: 'Unknown' };

        setWeather({
          city: city || null,
          temp: Math.round(temperature),
          emoji,
          label,
        });
      } catch {
        // silently fail
      }
    }

    fetchWeather();
    return () => { cancelled = true; };
  }, []);

  return (
    <WeatherContext.Provider value={weather}>
      {children}
    </WeatherContext.Provider>
  );
}

export function useWeather() {
  return useContext(WeatherContext);
}
